module.exports = __webpack_public_path__ + "845f49ca5a5d33972a0c0550199d110e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/misc/exit_fullscreen.svg
// module id = 27
// module chunks = 0